<!-- <div> -->
    <!-- <a href="https://api.whatsapp.com/send?phone=966544613666" target="_blank" class="whatsapp-icon"><img src="../../assets/img/whatsapp-icon.svg" alt=""></a> -->
    <!-- <a href="https://api.whatsapp.com/send?phone=910000000000&text=Hello this is the starting message">Whatsapp Chat</a> -->
<!-- </div> -->

<app-preloader></app-preloader>
<app-navbar></app-navbar>
<router-outlet></router-outlet>
<app-footer></app-footer>